'use client'

import { Spacer } from '@vinted/web-ui'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ShowAtBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { MediaUploadPhotoDto } from '@marketplace-web/item-upload/media-upload-data'
import { urlWithParams } from '@marketplace-web/browser/url-util'

import { CREATE_BUNDLE_URL } from '../../../constants/routes'
import AddMoreItems from './AddMoreItems'
import Upload from './Upload'

type Props = {
  isInputExpanded: boolean
  isConversationUploadEnabled: boolean
  isSellerCountdownActive: boolean | undefined
  storeImage: (image: MediaUploadPhotoDto) => void
  onError?: (data: string | JSX.Element) => void
}

const ComposerActions = ({
  isInputExpanded,
  isConversationUploadEnabled,
  isSellerCountdownActive,
  storeImage,
  onError,
}: Props) => {
  const { conversation } = useConversationContext()

  const showBundleAction = conversation?.isBundleAvailable && !isSellerCountdownActive

  const renderAddMoreItemsUrl = () => {
    if (!conversation?.transaction) return null

    const { id: transactionId, seller, order } = conversation.transaction

    if (!seller?.id) return null

    return urlWithParams(CREATE_BUNDLE_URL(seller.id.toString()), {
      transaction_id: transactionId,
      item_ids: order.itemIds,
    })
  }

  const renderActions = () => {
    if (!conversation) return null

    if (!isConversationUploadEnabled && !showBundleAction) return null

    return (
      <div className="u-flexbox u-flexbox-column">
        <div className="u-flexbox">
          {showBundleAction && <AddMoreItems addMoreItemsUrl={renderAddMoreItemsUrl()} />}
          {isConversationUploadEnabled && (
            <Upload conversation={conversation} storeImage={storeImage} onError={onError} />
          )}
        </div>
        <Spacer size="large" />
      </div>
    )
  }

  return (
    <>
      <ShowAtBreakpoint breakpoint="phones">{!isInputExpanded && renderActions()}</ShowAtBreakpoint>
      <ShowAtBreakpoint breakpoint="tabletsUp">{renderActions()}</ShowAtBreakpoint>
    </>
  )
}

export default ComposerActions
